<mat-form-field>
  <mat-select
    [(value)]="event.officialsCallAssessment"
    (selectionChange)="selectionChange.emit($event)"
  >
    <mat-option
      *ngFor="let option of allOfficialsCallAssessments"
      [value]="option.key"
    >
      {{ option.description }}
    </mat-option>
  </mat-select>
</mat-form-field>
